module.exports = __webpack_public_path__ + "static/img/fundo.993e20d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fundo.jpg
// module id = 201
// module chunks = 10